export class CreateSignatureMessages {
  public fileMax = 'create_signature.file_max';
  public fileMin = 'create_signature.file_min';
  public sign = 'create_signature.sign';

  constructor() {
  }
}
